import mapActions from './mapActions';

export default mapActions('stores', {
    fetchAll_url: () => '/api/storage/stores'
});
